import React from 'react'
import PropTypes from 'prop-types'
import PageContainer from 'layout/default-sidebar-layout/PageContainer'
import { autobind } from 'core-decorators'
import { message } from 'antd'
import createLanguageHoc, { langPropTypes } from 'hoc/create-lang'
import { getOrgHook, updateOrgHook } from '../../api/hook'
import Breadcrumb from 'containers/hook/breadcrumb'
import HookForm from './form'



@createLanguageHoc
@autobind
export default class HookPage extends React.Component {
  static propTypes = {
    dataSource: PropTypes.array,
    isLoading: PropTypes.bool,
    pagination: PropTypes.object,
    onChangePage: PropTypes.func,
    onChangePageSize: PropTypes.func,
    onDeleteItem: PropTypes.func,
    fetchData: PropTypes.func,
    lang: langPropTypes
  }

  state = {
    orgHook: {
      create: '',
      update: '',
      delete: ''
    }
  }

  async componentDidMount() {
    const orgHook = await getOrgHook()
    this.setState({
      orgHook: Object.assign({}, this.state.orgHook, orgHook),
    })
  }

  async onSubmit(data) {
    try {
      await updateOrgHook(data)
      message.success('Update success')
    }
    catch (error) {
      message.error('Update error')
    }
  }

  render() {
    return (
      <PageContainer>
        <Breadcrumb items={[ 'hook' ]} />
        <HookForm onSubmit={this.onSubmit} initialValues={this.state} />
      </PageContainer >
    )
  }
} 


// WEBPACK FOOTER //
// ./src/containers/hook/hook.js